import StatusCellRenderer from '~/components/cellRenderers/StatusCellRenderer';
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from '~/constants/pagination';
export class GridConfigFactory {
    linePlanEntityConfigs = {
        model: {
            columnDefsFactory: () => this.createProductColumnDefs(),
            masterDetailEnabled: true
        },
        expression: {
            columnDefsFactory: () => this.createExpressionColumnDefs(),
            masterDetailEnabled: false
        },
        project: {
            columnDefsFactory: () => this.createProjectColumnDefs(),
            masterDetailEnabled: false
        },
        style: {
            columnDefsFactory: () => this.createStyleColumnDefs(),
            masterDetailEnabled: false
        },
        product: {
            columnDefsFactory: () => this.createStyleColumnDefs(),
            masterDetailEnabled: false
        }
    };
    constructor() { }
    createDetailColumnDefs() {
        return [
            {
                field: 'productId',
                headerName: 'Product ID',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 150
            },
            {
                field: 'productCode',
                headerName: 'Product Code',
                sortable: true,
                filter: true,
                width: 170
            },
            {
                field: 'colorDescription',
                headerName: 'Color Description',
                sortable: true,
                filter: true,
                width: 250
            },
            {
                field: 'colorCode',
                headerName: 'Color Code',
                sortable: true,
                filter: true,
                width: 150
            },
            {
                field: 'primaryColor',
                headerName: 'Primary Color',
                sortable: true,
                filter: true,
                width: 180
            },
            {
                field: 'secondaryColor',
                headerName: 'Secondary Color',
                sortable: true,
                filter: true,
                width: 200
            },
            {
                field: 'materialIntent',
                headerName: 'Material Intent',
                sortable: true,
                filter: true,
                width: 180
            },
            {
                field: 'retailSizeRange',
                headerName: 'Size Range',
                sortable: true,
                filter: true,
                width: 200
            },
            {
                field: 'technologies',
                headerName: 'Technologies',
                sortable: true,
                filter: true,
                width: 180,
                valueFormatter: (params) => {
                    return Array.isArray(params.value) ? params.value.join(', ') : '';
                }
            },
            {
                field: 'features',
                headerName: 'Features',
                sortable: true,
                filter: true,
                width: 180,
                valueFormatter: (params) => {
                    return Array.isArray(params.value) ? params.value.join(', ') : '';
                }
            },
            {
                field: 'status',
                headerName: 'Status',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 150,
                cellRenderer: StatusCellRenderer
            },
            {
                field: 'lastModified',
                headerName: 'Last Modified',
                sortable: true,
                filter: 'agDateColumnFilter',
                width: 180,
                valueFormatter: (params) => {
                    if (!params.value)
                        return '';
                    return new Date(params.value).toLocaleDateString();
                }
            }
        ];
    }
    createProductColumnDefs() {
        const baseCols = [
            {
                field: 'modelId',
                headerName: 'Model ID',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 150,
                cellRenderer: 'agGroupCellRenderer',
                cellRendererParams: {
                    suppressCount: true
                }
            },
            {
                field: 'modelName',
                headerName: 'Model Name',
                sortable: true,
                filter: true,
                width: 250
            },
            {
                field: 'age',
                headerName: 'Age',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 100,
                enableRowGroup: true
            },
            {
                field: 'active',
                headerName: 'Active',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 150,
                cellRenderer: StatusCellRenderer,
                enableRowGroup: true
            },
            {
                field: 'construction',
                headerName: 'Construction',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 160
            },
            {
                field: 'division',
                headerName: 'Division',
                sortable: true,
                filter: true,
                width: 230,
                enableRowGroup: true
            },
            {
                field: 'family',
                headerName: 'Family',
                sortable: true,
                filter: true,
                width: 170,
                enableRowGroup: true
            },
            {
                field: 'fitPreference',
                headerName: 'Fit Preference',
                sortable: true,
                filter: true,
                width: 180
            },
            {
                field: 'franchise',
                headerName: 'Franchise',
                sortable: true,
                filter: true,
                width: 150,
                enableRowGroup: true
            },
            {
                field: 'gender',
                headerName: 'Gender',
                sortable: true,
                filter: true,
                width: 150,
                enableRowGroup: true
            },
            {
                field: 'midsoleDescription',
                headerName: 'Midsole Description',
                sortable: true,
                filter: true,
                width: 200
            },
            {
                field: 'modelGroups',
                headerName: 'Model Groups',
                sortable: true,
                filter: true,
                width: 200
            },
            {
                field: 'outsoleDescription',
                headerName: 'Outsole Description',
                sortable: true,
                filter: true,
                width: 200
            },
            {
                field: 'platforms',
                headerName: 'Platforms',
                sortable: true,
                filter: true,
                width: 150
            },
            {
                field: 'plate',
                headerName: 'Plate',
                sortable: true,
                filter: true,
                width: 150
            },
            {
                field: 'rise',
                headerName: 'Rise',
                sortable: true,
                filter: true,
                width: 100
            },
            {
                field: 'silhouette',
                headerName: 'Silhouette',
                sortable: true,
                filter: true,
                width: 150,
                enableRowGroup: true
            },
            {
                field: 'silhouetteType',
                headerName: 'Silhouette Type',
                sortable: true,
                filter: true,
                width: 200,
                enableRowGroup: true
            },
            {
                field: 'sportActivity',
                headerName: 'Sport Activity',
                sortable: true,
                filter: true,
                width: 160,
                enableRowGroup: true
            },
            {
                field: 'status',
                headerName: 'Status',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 120,
                cellRenderer: StatusCellRenderer,
                enableRowGroup: true
            },
            {
                field: 'subBrand',
                headerName: 'Sub Brand',
                sortable: true,
                filter: true,
                width: 180,
                enableRowGroup: true
            },
            {
                field: 'subFamily',
                headerName: 'Sub Family',
                sortable: true,
                filter: true,
                width: 150,
                enableRowGroup: true
            },
            {
                field: 'upperDescription',
                headerName: 'Upper Description',
                sortable: true,
                filter: true,
                width: 250
            },
            {
                field: 'lastModified',
                headerName: 'Last Modified',
                sortable: true,
                filter: 'agDateColumnFilter',
                width: 180
            },
            {
                field: 'lastModifiedBy',
                headerName: 'Last Modified By',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 200
            }
        ];
        return baseCols;
    }
    createExpressionColumnDefs() {
        const cols = [
            {
                field: 'id',
                headerName: 'ID',
                sortable: true,
                filter: 'agTextColumnFilter',
                width: 100,
                hide: true
            },
            {
                field: 'expressionName',
                headerName: 'Expression Name',
                sortable: true,
                filter: true,
                width: 260
            },
            {
                field: 'expressionType.label',
                headerName: 'Expression Type',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 200,
                valueGetter: (p) => p.data?.expressionType?.label
            },
            {
                field: 'brand.label',
                headerName: 'Brand',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 140,
                valueGetter: (p) => p.data?.brand?.label
            },
            {
                field: 'division.label',
                headerName: 'Division',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 140,
                valueGetter: (p) => p.data?.division?.label
            },
            {
                field: 'fieldOfPlay.label',
                headerName: 'Field of Play',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 160,
                valueGetter: (p) => p.data?.fieldOfPlay?.label
            },
            {
                field: 'gender.label',
                headerName: 'Gender',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 120,
                valueGetter: (p) => p.data?.gender?.label
            },
            {
                field: 'age.label',
                headerName: 'Age',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 120,
                valueGetter: (p) => p.data?.age?.label
            },
            {
                field: 'upcharge',
                headerName: 'Upcharge',
                sortable: true,
                filter: 'agNumberColumnFilter',
                width: 120,
                valueFormatter: (params) => {
                    const value = params.data?.upcharge;
                    if (!value)
                        return '';
                    return `$${value}`;
                }
            },
            {
                field: 'specialEdition',
                headerName: 'Special Edition',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 150,
                valueFormatter: (params) => {
                    return params.data?.specialEdition ? 'Yes' : 'No';
                }
            },
            {
                field: 'lifecycle',
                headerName: 'Lifecycle',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 140,
                valueGetter: (p) => p.data?.lifecycle?.label || ''
            },
            {
                field: 'expressionIntent',
                headerName: 'Expression Intent',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 180,
                valueGetter: (p) => p.data?.expressionIntent || ''
            },
            {
                field: 'styleType',
                headerName: 'Style Type',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 150,
                valueGetter: (p) => p.data?.styleType?.label || ''
            },
            {
                field: 'materialType',
                headerName: 'Material Type',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 150,
                valueGetter: (p) => p.data?.materialType?.label || ''
            },
            {
                field: 'spectrumType',
                headerName: 'Spectrum Type',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 150,
                valueGetter: (p) => p.data?.spectrumType?.label || ''
            },
            {
                field: 'seasons',
                headerName: 'Seasons',
                sortable: true,
                filter: true,
                width: 200,
                valueFormatter: (params) => {
                    const seasons = params.data?.seasons;
                    if (!Array.isArray(seasons) || seasons.length === 0)
                        return '';
                    return seasons.map((s) => s.label).join(', ');
                }
            },
            {
                field: 'keyGeo',
                headerName: 'Key Geo',
                sortable: true,
                filter: true,
                width: 150
            },
            {
                field: 'createdAt',
                headerName: 'Created At',
                sortable: true,
                filter: 'agDateColumnFilter',
                width: 180,
                valueFormatter: (params) => {
                    if (!params.data?.createdAt)
                        return '';
                    return new Date(params.data.createdAt).toLocaleDateString();
                }
            },
            {
                field: 'updatedAt',
                headerName: 'Updated At',
                sortable: true,
                filter: 'agDateColumnFilter',
                width: 180,
                valueFormatter: (params) => {
                    if (!params.data?.updatedAt)
                        return '';
                    return new Date(params.data.updatedAt).toLocaleDateString();
                }
            }
        ];
        return cols;
    }
    createProjectColumnDefs() {
        return [
            {
                field: 'id',
                headerName: 'ID',
                sortable: true,
                filter: true,
                width: 100
            },
            {
                field: 'projectName',
                headerName: 'Project Name',
                sortable: true,
                filter: true,
                width: 250
            },
            {
                field: 'sportActivity',
                headerName: 'Sport Activity',
                sortable: true,
                filter: true,
                width: 150,
                valueGetter: (params) => params.data?.sportActivity?.label || ''
            },
            {
                field: 'franchise',
                headerName: 'Franchise',
                sortable: true,
                filter: true,
                width: 150,
                enableRowGroup: true,
                valueGetter: (params) => params.data?.franchise?.label || ''
            },
            {
                field: 'silo',
                headerName: 'Silo',
                sortable: true,
                filter: true,
                width: 130,
                enableRowGroup: true,
                valueGetter: (params) => params.data?.silo?.label || ''
            },
            {
                field: 'strategicIntent',
                headerName: 'Strategic Intent',
                sortable: true,
                filter: true,
                width: 200,
                valueGetter: (params) => params.data?.strategicIntent?.label || ''
            },
            {
                field: 'msrp',
                headerName: 'MSRP',
                sortable: true,
                filter: true,
                width: 120,
                valueFormatter: (params) => {
                    return params.value ? `$${params.value}` : '';
                }
            },
            {
                field: 'fob',
                headerName: 'FOB',
                sortable: true,
                filter: true,
                width: 120,
                valueFormatter: (params) => {
                    return params.value ? `$${params.value}` : '';
                }
            },
            {
                field: 'targetGeo',
                headerName: 'Target Geo',
                sortable: true,
                filter: true,
                width: 120
            },
            {
                field: 'newTool',
                headerName: 'New Tool',
                sortable: true,
                filter: true,
                width: 150
            },
            {
                field: 'margin',
                headerName: 'Margin',
                sortable: true,
                filter: true,
                width: 100
            },
            {
                field: 'production',
                headerName: 'Production',
                sortable: true,
                filter: true,
                width: 150
            }
        ];
    }
    createStyleColumnDefs() {
        const styleCols = [
            {
                field: 'styleNumber',
                headerName: 'Style Number',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 150,
                enableRowGroup: true
            },
            {
                field: 'styleName',
                headerName: 'Style Name',
                sortable: true,
                filter: true,
                width: 250
            },
            {
                field: 'modelId',
                headerName: 'Model ID',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 150,
                enableRowGroup: true
            },
            {
                field: 'modificationDate',
                headerName: 'Last Modified',
                sortable: true,
                filter: 'agDateColumnFilter',
                width: 180,
                valueFormatter: (params) => {
                    if (!params.value)
                        return '';
                    return new Date(params.value).toLocaleDateString();
                }
            },
            {
                field: 'modifiedBy',
                headerName: 'Modified By',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 200
            },
            {
                field: 'deliveryUnit',
                headerName: 'Delivery Unit',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 150,
                enableRowGroup: true
            },
            {
                field: 'dimension',
                headerName: 'Dimension',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 150,
                enableRowGroup: true
            },
            {
                field: 'fit',
                headerName: 'Fit',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 120
            },
            {
                field: 'licensed',
                headerName: 'Licensed',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 120,
                enableRowGroup: true,
                valueFormatter: (params) => {
                    return params.value ? 'Yes' : 'No';
                }
            },
            {
                field: 'merchandisingClassification',
                headerName: 'Merch Classification',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 200,
                enableRowGroup: true
            },
            {
                field: 'segment',
                headerName: 'Segment',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 150,
                enableRowGroup: true
            },
            {
                field: 'sizeScale',
                headerName: 'Size Scale',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 130
            },
            {
                field: 'styleSportActivity',
                headerName: 'Sport Activity',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 160,
                enableRowGroup: true
            },
            {
                field: 'entryIntoMarket',
                headerName: 'Entry Into Market',
                sortable: true,
                filter: 'agDateColumnFilter',
                width: 180
            },
            {
                field: 'athlete',
                headerName: 'Athlete',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 150,
                enableRowGroup: true
            },
            {
                field: 'league',
                headerName: 'League',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 120,
                enableRowGroup: true
            },
            {
                field: 'styleGroups',
                headerName: 'Style Groups',
                sortable: true,
                filter: true,
                width: 200,
                valueFormatter: (params) => {
                    return Array.isArray(params.value) ? params.value.join(', ') : '';
                }
            },
            {
                field: 'eventOrMoment',
                headerName: 'Event/Moment',
                sortable: true,
                filter: 'agSetColumnFilter',
                width: 180
            },
            {
                field: 'exitFromMarket',
                headerName: 'Exit From Market',
                sortable: true,
                filter: 'agDateColumnFilter',
                width: 180
            }
        ];
        return styleCols;
    }
    createDefaultColDef() {
        return {
            resizable: true,
            sortable: true,
            filter: true,
            floatingFilter: false,
            menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab']
        };
    }
    createGridOptions() {
        return {
            pagination: true,
            paginationPageSize: DEFAULT_PAGE_SIZE,
            paginationPageSizeSelector: [...PAGE_SIZE_OPTIONS],
            rowSelection: 'multiple',
            suppressRowClickSelection: true,
            enableCellTextSelection: true,
            ensureDomOrder: true,
            animateRows: true,
            rowGroupPanelShow: 'always',
            enableRangeSelection: false,
            enableAdvancedFilter: false,
            masterDetail: true,
            detailCellRenderer: 'agDetailCellRenderer',
            detailCellRendererParams: {
                detailGridOptions: {
                    columnDefs: this.createDetailColumnDefs(),
                    defaultColDef: {
                        resizable: true,
                        sortable: true,
                        filter: true
                    },
                    pagination: true,
                    paginationPageSize: 10
                },
                getDetailRowData: (params) => {
                    params.successCallback(params.data.products || []);
                }
            },
            isRowMaster: (dataItem) => {
                const item = dataItem;
                return Array.isArray(item.products) && item.products.length > 0;
            },
            sideBar: {
                toolPanels: [
                    {
                        id: 'columns',
                        labelDefault: 'Columns',
                        labelKey: 'columns',
                        iconKey: 'columns',
                        toolPanel: 'agColumnsToolPanel'
                    }
                ],
                defaultToolPanel: '',
                hiddenByDefault: false
            },
            statusBar: {
                statusPanels: [
                    { statusPanel: 'agTotalAndFilteredRowCountComponent' },
                    { statusPanel: 'agSelectedRowCountComponent' },
                    { statusPanel: 'agAggregationComponent' }
                ]
            }
        };
    }
    createProductGridConfig(rowData, linePlanEntity = 'model') {
        const config = this.linePlanEntityConfigs[linePlanEntity];
        const columnDefs = config.columnDefsFactory();
        const gridOptions = this.createGridOptions();
        if (!config.masterDetailEnabled) {
            gridOptions.masterDetail = false;
            gridOptions.isRowMaster = () => false;
        }
        return {
            columnDefs,
            rowData,
            defaultColDef: this.createDefaultColDef(),
            gridOptions
        };
    }
}
export const gridConfigFactory = new GridConfigFactory();
